﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as dataGatheringModel from "~base/Services/API/DataGathering/Model";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (operationId: string): string => {
    return `api/DataGathering/v1/Operations/${operationId}`;
};

const method = "GET";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface GetOperationQsParams {
    operationId?: string;
}

interface GetOperationProps
    extends
        GetOperationQsParams,
        api.ApiHookBaseProps<
            unknown,
            dataGatheringModel.GetOperationResponse,
            unknown
        > {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function useGetOperation(
    props: GetOperationProps
): [boolean, () => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        unknown,
        dataGatheringModel.GetOperationResponse,
        unknown
    > = {
        ...props,
        uri: uri(props.operationId),
        method: method,
        allowSerialCalls: true,
    };

    const [loading, invoker] = api.useApi<
        unknown,
        dataGatheringModel.GetOperationResponse,
        unknown
    >(apiParams);
    return [loading, () => invoker(apiParams.uri, undefined)];
}
